/* eslint-disable react/react-in-jsx-scope */
import "./WhyTotem.scss";
import { useContext } from "react";
import { LangContext } from "../../context/langContext";
import whyTotemImage from "../../assets/why-totem-chat.png";

const WhyTotem = ({ textData }) => {
  const lang = useContext(LangContext);

  return (
    <section className="why-totem" id="why-totem">
      <div className="why-totem__image-container why-totem__image-container_desktop">
        <img src={whyTotemImage} alt="" className="why-totem__image" />
        <div className="why-totem__gradient" />
        <div className="star star_top" />
        <div className="star star_middle" />
        <div className="star star_bottom" />
      </div>
      <div className="why-totem__info">
        <h2 className=" why-totem__title">{textData[lang].whyTotem.title}</h2>
        <div className="why-totem__image-container why-totem__image-container_mobile">
          <img src={whyTotemImage} alt="" className="why-totem__image" />
          <div className="why-totem__gradient" />
          <div className="star star_top" />
          <div className="star star_middle" />
          <div className="star star_bottom" />
        </div>
        <p className="why-totem__desc">{textData[lang].whyTotem.desc}</p>
      </div>
    </section>
  );
};

export default WhyTotem;
